<div class="mb-table-scroll">
  <ng-content></ng-content>
</div>
